export default "__VITE_ASSET__DLN_DGzd__"